const { sin, cos, pow, PI } = Math

export const easeOutSine = t => sin(0.5 * PI * t)
export const easeInOutSine = t => -0.5 * cos(PI * t) + 0.5

export const easeOutQuad = t => -1 * (t - 1) ** 2 + 1

export function easeOutElastic(t) {
	const period = 0.6
	const amplitude = 1
	const offset = period / 4
	return (
		amplitude * pow(2, -10 * t) * sin(((t - offset) * (PI * 2)) / period) + 1
	)
}
